import React, { useTransition } from 'react'

import { Button, Stack, Typography } from '@mui/material'
import { LockPerson } from '@mui/icons-material'

import { useToast } from '@/contexts/ToastContext'

import { useAuth } from '@/hooks/useAuth'
import { useBiometric } from '@/hooks/useBiometric'

import { HttpError } from '@/api/http'

interface BiometricLoginButtonProps {
  onSuccess: () => void
  disabled?: boolean
}

const BiometricLoginButton: React.FC<BiometricLoginButtonProps> = ({ onSuccess, disabled }) => {
  const toast = useToast()
  const { loginWithBiometric } = useAuth()
  const biometryMethods = useBiometric()
  const [isPending, startTransition] = useTransition()

  const handleClick = () => {
    startTransition(async () => {
      try {
        await biometryMethods.authenticate(`Entrar no MicroRED com biometria`)
      } catch (error) {
        if (!biometryMethods.isUserCancel(error)) toast.error('Falha na autenticação biométrica. Use sua senha.')
        return
      }

      try {
        await loginWithBiometric()
        onSuccess()
      } catch (error) {
        toast.error((error as HttpError).message || 'Sessão expirada. Faça login com sua senha para continuar.')
      }
    })
  }

  return (
    <Stack alignItems="center" spacing={1} sx={{ width: '100%' }}>
      <Button
        variant="outlined"
        color="primary"
        fullWidth
        sx={{ borderRadius: 20 }}
        startIcon={<LockPerson />}
        onClick={handleClick}
        disabled={disabled || isPending}
        disableElevation
      >
        Entrar com biometria
      </Button>
      <Typography variant="caption" color="text.secondary">
        ou entre com CPF e senha
      </Typography>
    </Stack>
  )
}

export default BiometricLoginButton
